<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QAp4Ps/tc-custom/9781460360743.jpg?1726755981706" alt="This image is the cover for the book Deserted Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deserted Bride
      </h1>
      <p class="bookDescription body article font2">
        <p>Bess was a girl when she first saw her husband on their wedding day. Andrew, Earl of Exford, left after the ceremony, and as Bess blossomed into a lovely woman, she reveled in the freedom afforded by her absent spouse. Yet she knew the day would come when she would come face-to-face with her long-estranged husband.<br/><br/>On the day of his return, Drew found himself speechless at his wife's heart-stopping beauty and charm. Could it be that this once awkward girl was the bride he had deserted so long ago? Furthermore, could she ever forgive his cruel neglect and return his love?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paula Marshall
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fc80830